import React from "react";

export default function FromCustomFormulations() {
  return (
    <section
      className="w-full py-6 px-4 sm:px-6 lg:px-8"
      style={{
        background: "linear-gradient(to bottom, #5E7F3E, #759742)"
      }}
    >
      <div className="mx-auto">
        <div className="flex flex-col items-center justify-center gap-4 sm:gap-6">
          <h2 className="text-center text-white font-bold text-base lg:text-[22px] sm:leading-relaxed tracking-wide">
            FROM CUSTOM FORMULATIONS TO LOGO PRINTING, NUTRALIKE HELPS BUSINESSES CREATE PRODUCTS THAT STAND OUT IN THE NUTRACEUTICAL MARKET.
          </h2>
        </div>
      </div>
    </section>
  );
}